export const offsiteYears = [
  {
    slug: 'offsite-2016',
    city: 'New Orleans',
    year: '2016',
    heroImage: 'https://ore.design/wp-content/uploads/2024/09/ore_2016.10.21-045-1024x562.png',
    cardImage: 'https://ore.design/wp-content/uploads/2025/09/New-Orleans-300x300.jpg',
    location: { name: 'New Orleans Jazz Market' },
    highlights: [
      { label: 'Keynote', name: 'Cliff Garten', description: 'Landscape architect and sculptor' },
      { label: 'Live Music', name: 'Live Jazz Band' },
    ],
    panel: [
      { name: 'Cliff Garten', title: 'Landscape architect and sculptor' },
      { name: 'Angela Adams', title: 'Director of public art in Arlington, VA' },
      { name: 'Todd Bressi', title: 'Public art and culture planner based in Philadelphia, PA' },
      { name: 'Liesel Fenner', title: 'ASLA Panel moderator and public art program director for the state of Maryland' },
    ],
  },
  {
    slug: 'offsite-2017',
    city: 'Los Angeles',
    year: '2017',
    heroImage: 'https://ore.design/wp-content/uploads/2024/09/C3A9813-1024x683-1-1024x562.png',
    cardImage: 'https://ore.design/wp-content/uploads/2025/08/a210b0a2ad22e99537b396f83772a379-300x300.png',
    location: { name: 'MOCA', description: 'Los Angeles Museum of Contemporary Art' },
    highlights: [
      { label: 'Keynote', name: 'Janet Echelmen', description: 'Internationally acclaimed fiber artist, Guggenheim Fellow, and Architectural Digest Innovator known for her large-scale, aerial sculptures that blend art, architecture, and engineering' },
      { label: 'Live Music', name: 'Joshua Payne' },
    ],
    panel: [],
  },
  {
    slug: 'offsite-2018',
    city: 'Philadelphia',
    year: '2018',
    heroImage: 'https://ore.design/wp-content/uploads/2024/09/ore_2016.10.21-045-1-1024x562.png',
    cardImage: 'https://ore.design/wp-content/uploads/2025/08/9ba2f899733ed03fa7d4c1124c3faabe-298x300.png',
    location: {
      name: "Philadelphia's Barnes Foundation and Collection",
      description: 'A renowned art institution known for its impressive collection of post-impressionist and early modern paintings.',
    },
    highlights: [
      { label: 'Keynote', name: 'Dr. Leyla Acaroglu', description: 'Award-winning designer, sustainability provocateur, social scientist and entrepreneur' },
    ],
    panel: [],
  },
  {
    slug: 'offsite-2019',
    city: 'San Diego',
    year: '2019',
    heroImage: 'https://ore.design/wp-content/uploads/2024/08/ore-72-of-243-1024x683.jpg',
    cardImage: 'https://ore.design/wp-content/uploads/2025/08/4354c47457dc422dab204c4e24781ec1-300x300.png',
    location: { name: 'The Quartyard' },
    highlights: [
      { label: 'Keynote', name: 'Philip Auchettl', description: 'Architect & Developer of RAD LAB' },
      { label: "Hors D'oeuvres", name: 'Chef Evan François' },
      { label: 'Live Music', name: 'Joshy Soul + The Cool' },
    ],
    panel: [],
  },
  {
    slug: 'offsite-2024',
    city: 'Washington D.C.',
    year: '2024',
    heroImage: 'https://ore.design/wp-content/uploads/2025/08/2024_offsite_image.png',
    cardImage: 'https://ore.design/wp-content/uploads/2025/08/Offsite-2024-1-300x300.png',
    location: { name: 'Long View Gallery' },
    highlights: [
      { label: 'Artwork', name: 'Gary Vlasic' },
      { label: 'Live Music', name: 'Joshua Payne Orchestra' },
    ],
    panel: [],
  },
  {
    slug: 'offsite-2025',
    city: 'New Orleans',
    year: '2025',
    heroImage: 'https://ore.design/wp-content/uploads/2025/10/ORE_Design-OFFSITE-Website-1-1025-1024x633.jpg',
    cardImage: 'https://ore.design/wp-content/uploads/2025/10/ORE_Design-OFFSITE-Website-Carousel-1-1025.jpg',
    location: { name: 'Merchant Hall', description: 'New Orleans, Louisiana' },
    highlights: [
      { label: 'Installation', name: 'A new architectural elements installation celebrating material innovation and placemaking' },
      { label: 'Playlist', name: 'ORE OFFSITE New Orleans 2025' },
    ],
    panel: [],
  },
]
